import { render, staticRenderFns } from "./LectorsParticipationGrid.vue?vue&type=template&id=0c229334"
import script from "./LectorsParticipationGrid.vue?vue&type=script&lang=js"
export * from "./LectorsParticipationGrid.vue?vue&type=script&lang=js"
import style0 from "./LectorsParticipationGrid.vue?vue&type=style&index=0&id=0c229334&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports